export default __webpack_public_path__ + "static/media/warning--pavement-ahead--g1.7a325168.png";